import { render, staticRenderFns } from "./NewEditMenu.vue?vue&type=template&id=c90c0eec&"
import script from "../../models/app-design/new-edit-menu.ts?vue&type=script&lang=ts&"
export * from "../../models/app-design/new-edit-menu.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports